import { isAppHost } from "@/lib/site/hosts";

/**
 * Whether Sentry Session Replay runs on this host: only in the app
 * (app.zettl.cz), never on the public site, previews or local builds. The
 * cookie policy describes the recording as something that happens when an
 * error occurs in the app, and replays are kept to errors only
 * (replaysOnErrorSampleRate in main.tsx).
 */
export function wantsSessionReplay(hostname: string): boolean {
  return isAppHost(hostname);
}
